Object.defineProperty(exports, "__esModule", {
    value: true
});
var _async_to_generator = require("@swc/helpers/_/_async_to_generator");
var _class_call_check = require("@swc/helpers/_/_class_call_check");
var _create_class = require("@swc/helpers/_/_create_class");
var _object_spread = require("@swc/helpers/_/_object_spread");
var _object_spread_props = require("@swc/helpers/_/_object_spread_props");
var require_logger = require('../../utils/logger.cjs');
var require_tool = require('../../utils/tool.cjs');
var require_global = require('../../global.cjs');
var require_load = require('../../utils/load.cjs');
var require_context = require('../../utils/context.cjs');
require('../../utils/index.cjs');
var require_asyncHook = require('../../utils/hooks/asyncHook.cjs');
var require_asyncWaterfallHooks = require('../../utils/hooks/asyncWaterfallHooks.cjs');
var require_pluginSystem = require('../../utils/hooks/pluginSystem.cjs');
require('../../utils/hooks/index.cjs');
var _module_federation_sdk = require("@module-federation/sdk");
var _module_federation_error_codes = require("@module-federation/error-codes");
//#region src/plugins/snapshot/SnapshotHandler.ts
function getGlobalRemoteInfo(moduleInfo, origin) {
    var hostGlobalSnapshot = require_global.getGlobalSnapshotInfoByModuleInfo({
        name: origin.name,
        version: origin.options.version
    });
    var globalRemoteInfo = hostGlobalSnapshot && "remotesInfo" in hostGlobalSnapshot && hostGlobalSnapshot.remotesInfo && require_global.getInfoWithoutType(hostGlobalSnapshot.remotesInfo, moduleInfo.name).value;
    if (globalRemoteInfo && globalRemoteInfo.matchedVersion) return {
        hostGlobalSnapshot,
        globalSnapshot: require_global.getGlobalSnapshot(),
        remoteSnapshot: require_global.getGlobalSnapshotInfoByModuleInfo({
            name: moduleInfo.name,
            version: globalRemoteInfo.matchedVersion
        })
    };
    return {
        hostGlobalSnapshot: void 0,
        globalSnapshot: require_global.getGlobalSnapshot(),
        remoteSnapshot: require_global.getGlobalSnapshotInfoByModuleInfo({
            name: moduleInfo.name,
            version: "version" in moduleInfo ? moduleInfo.version : void 0
        })
    };
}
var SnapshotHandler = /*#__PURE__*/ function() {
    "use strict";
    function SnapshotHandler(HostInstance) {
        _class_call_check._(this, SnapshotHandler);
        this.loadingHostSnapshot = null;
        this.manifestCache = /* @__PURE__ */ new Map();
        this.hooks = new require_pluginSystem.PluginSystem({
            beforeLoadRemoteSnapshot: new require_asyncHook.AsyncHook("beforeLoadRemoteSnapshot"),
            loadSnapshot: new require_asyncWaterfallHooks.AsyncWaterfallHook("loadGlobalSnapshot"),
            loadRemoteSnapshot: new require_asyncWaterfallHooks.AsyncWaterfallHook("loadRemoteSnapshot"),
            afterLoadSnapshot: new require_asyncWaterfallHooks.AsyncWaterfallHook("afterLoadSnapshot")
        });
        this.manifestLoading = require_global.Global.__FEDERATION__.__MANIFEST_LOADING__;
        this.HostInstance = HostInstance;
        this.loaderHook = HostInstance.loaderHook;
    }
    _create_class._(SnapshotHandler, [
        {
            key: "loadRemoteSnapshotInfo",
            value: function loadRemoteSnapshotInfo(_0) {
                return _async_to_generator._(function*(param) {
                    var moduleInfo = param.moduleInfo, id = param.id, expose = param.expose;
                    var options = this.HostInstance.options;
                    yield this.hooks.lifecycle.beforeLoadRemoteSnapshot.emit({
                        options,
                        moduleInfo
                    });
                    var hostSnapshot = require_global.getGlobalSnapshotInfoByModuleInfo({
                        name: this.HostInstance.options.name,
                        version: this.HostInstance.options.version
                    });
                    if (!hostSnapshot) {
                        hostSnapshot = {
                            version: this.HostInstance.options.version || "",
                            remoteEntry: "",
                            remotesInfo: {}
                        };
                        require_global.addGlobalSnapshot({
                            [this.HostInstance.options.name]: hostSnapshot
                        });
                    }
                    if (hostSnapshot && "remotesInfo" in hostSnapshot && !require_global.getInfoWithoutType(hostSnapshot.remotesInfo, moduleInfo.name).value) {
                        if ("version" in moduleInfo || "entry" in moduleInfo) hostSnapshot.remotesInfo = _object_spread_props._(_object_spread._({}, hostSnapshot === null || hostSnapshot === void 0 ? void 0 : hostSnapshot.remotesInfo), {
                            [moduleInfo.name]: {
                                matchedVersion: "version" in moduleInfo ? moduleInfo.version : moduleInfo.entry
                            }
                        });
                    }
                    var _this_getGlobalRemoteInfo = this.getGlobalRemoteInfo(moduleInfo), hostGlobalSnapshot = _this_getGlobalRemoteInfo.hostGlobalSnapshot, remoteSnapshot = _this_getGlobalRemoteInfo.remoteSnapshot, globalSnapshot = _this_getGlobalRemoteInfo.globalSnapshot;
                    var _ref = yield this.hooks.lifecycle.loadSnapshot.emit({
                        options,
                        moduleInfo,
                        hostGlobalSnapshot,
                        remoteSnapshot,
                        globalSnapshot
                    }), globalRemoteSnapshot = _ref.remoteSnapshot, globalSnapshotRes = _ref.globalSnapshot;
                    var mSnapshot;
                    var gSnapshot;
                    if (globalRemoteSnapshot) if ((0, _module_federation_sdk.isManifestProvider)(globalRemoteSnapshot)) {
                        var remoteEntry = _module_federation_sdk.isBrowserEnvValue ? globalRemoteSnapshot.remoteEntry : globalRemoteSnapshot.ssrRemoteEntry || globalRemoteSnapshot.remoteEntry || "";
                        var moduleSnapshot = yield this.getManifestJson(remoteEntry, moduleInfo, {});
                        var globalSnapshotRes1 = require_global.setGlobalSnapshotInfoByModuleInfo(_object_spread_props._(_object_spread._({}, moduleInfo), {
                            entry: remoteEntry
                        }), moduleSnapshot);
                        mSnapshot = moduleSnapshot;
                        gSnapshot = globalSnapshotRes1;
                    } else {
                        var _ref1 = yield this.hooks.lifecycle.loadRemoteSnapshot.emit({
                            options: this.HostInstance.options,
                            moduleInfo,
                            remoteSnapshot: globalRemoteSnapshot,
                            from: "global"
                        }), remoteSnapshotRes = _ref1.remoteSnapshot;
                        mSnapshot = remoteSnapshotRes;
                        gSnapshot = globalSnapshotRes;
                    }
                    else if (require_tool.isRemoteInfoWithEntry(moduleInfo)) {
                        var moduleSnapshot1 = yield this.getManifestJson(moduleInfo.entry, moduleInfo, {});
                        var globalSnapshotRes2 = require_global.setGlobalSnapshotInfoByModuleInfo(moduleInfo, moduleSnapshot1);
                        var _ref2 = yield this.hooks.lifecycle.loadRemoteSnapshot.emit({
                            options: this.HostInstance.options,
                            moduleInfo,
                            remoteSnapshot: moduleSnapshot1,
                            from: "global"
                        }), remoteSnapshotRes1 = _ref2.remoteSnapshot;
                        mSnapshot = remoteSnapshotRes1;
                        gSnapshot = globalSnapshotRes2;
                    } else require_logger.error(_module_federation_error_codes.RUNTIME_007, _module_federation_error_codes.runtimeDescMap, {
                        remoteName: moduleInfo.name,
                        remoteVersion: moduleInfo.version,
                        hostName: this.HostInstance.options.name,
                        globalSnapshot: JSON.stringify(globalSnapshotRes)
                    }, void 0, require_context.optionsToMFContext(this.HostInstance.options));
                    yield this.hooks.lifecycle.afterLoadSnapshot.emit({
                        id,
                        host: this.HostInstance,
                        options,
                        moduleInfo,
                        remoteSnapshot: mSnapshot
                    });
                    return {
                        remoteSnapshot: mSnapshot,
                        globalSnapshot: gSnapshot
                    };
                }).apply(this, arguments);
            }
        },
        {
            key: "getGlobalRemoteInfo",
            value: function getGlobalRemoteInfo1(moduleInfo) {
                return getGlobalRemoteInfo(moduleInfo, this.HostInstance);
            }
        },
        {
            key: "getManifestJson",
            value: function getManifestJson(manifestUrl, moduleInfo, extraOptions) {
                return _async_to_generator._(function*() {
                    var getManifest = ()=>_async_to_generator._(function*() {
                            var manifestJson = this.manifestCache.get(manifestUrl);
                            if (manifestJson) return manifestJson;
                            try {
                                var res = yield this.loaderHook.lifecycle.fetch.emit(manifestUrl, {}, require_load.getRemoteInfo(moduleInfo));
                                if (!res || !(res instanceof Response)) res = yield fetch(manifestUrl, {});
                                manifestJson = yield res.json();
                            } catch (err) {
                                manifestJson = yield this.HostInstance.remoteHandler.hooks.lifecycle.errorLoadRemote.emit({
                                    id: manifestUrl,
                                    error: err,
                                    from: "runtime",
                                    lifecycle: "afterResolve",
                                    origin: this.HostInstance
                                });
                                if (!manifestJson) {
                                    delete this.manifestLoading[manifestUrl];
                                    require_logger.error(_module_federation_error_codes.RUNTIME_003, _module_federation_error_codes.runtimeDescMap, {
                                        manifestUrl,
                                        moduleName: moduleInfo.name,
                                        hostName: this.HostInstance.options.name
                                    }, `${err}`, require_context.optionsToMFContext(this.HostInstance.options));
                                }
                            }
                            require_logger.assert(manifestJson.metaData && manifestJson.exposes && manifestJson.shared, `"${manifestUrl}" is not a valid federation manifest for remote "${moduleInfo.name}". Missing required fields: ${[
                                !manifestJson.metaData && "metaData",
                                !manifestJson.exposes && "exposes",
                                !manifestJson.shared && "shared"
                            ].filter(Boolean).join(", ")}.`);
                            this.manifestCache.set(manifestUrl, manifestJson);
                            return manifestJson;
                        }).call(this);
                    var asyncLoadProcess = ()=>_async_to_generator._(function*() {
                            var manifestJson = yield getManifest();
                            var remoteSnapshot = (0, _module_federation_sdk.generateSnapshotFromManifest)(manifestJson, {
                                version: manifestUrl
                            });
                            var _ref = yield this.hooks.lifecycle.loadRemoteSnapshot.emit({
                                options: this.HostInstance.options,
                                moduleInfo,
                                manifestJson,
                                remoteSnapshot,
                                manifestUrl,
                                from: "manifest"
                            }), remoteSnapshotRes = _ref.remoteSnapshot;
                            return remoteSnapshotRes;
                        }).call(this);
                    if (!this.manifestLoading[manifestUrl]) this.manifestLoading[manifestUrl] = asyncLoadProcess().then((res)=>res);
                    return this.manifestLoading[manifestUrl];
                }).call(this);
            }
        }
    ]);
    return SnapshotHandler;
}();
//#endregion
exports.SnapshotHandler = SnapshotHandler;
exports.getGlobalRemoteInfo = getGlobalRemoteInfo; //# sourceMappingURL=SnapshotHandler.cjs.map
